// Seed prompts used when a user clicks a pattern or condition card and we
// jump them into the coach with a pre-composed first message. The phrasing is
// deliberately first-person and ends with a doctor-discussion ask — the goal
// is to turn an observation card into a conversation the user can actually
// take to their provider.

export function coachSeedForCondition(condition: string, message: string): string {
  const trimmed = (message || '').trim()
  const tail = trimmed
    ? trimmed.endsWith('.') || trimmed.endsWith('!') || trimmed.endsWith('?')
      ? trimmed
      : `${trimmed}.`
    : ''
  return [
    `Pelvia flagged a possible pattern around ${condition} in my data.`,
    tail && `Reasoning: ${tail}`,
    `Help me understand what this could mean and what I should bring up with my doctor.`,
  ]
    .filter(Boolean)
    .join(' ')
}

export function coachSeedForPattern(title: string, body: string): string {
  const trimmed = (body || '').trim()
  const tail = trimmed
    ? trimmed.endsWith('.') || trimmed.endsWith('!') || trimmed.endsWith('?')
      ? trimmed
      : `${trimmed}.`
    : ''
  return [
    `Pelvia noticed this pattern in my data — ${title}.`,
    tail,
    `What could be causing it, and what should I discuss with my doctor about it?`,
  ]
    .filter(Boolean)
    .join(' ')
}
